import React from 'react';
import styles from './Branding.module.scss';

export type LogoVariant = 'black' | 'white' | 'beige';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  /** Logo color variant - 'black' for light backgrounds, 'white' for dark backgrounds */
  variant?: LogoVariant;
  className?: string;
}

const LOGO_PATHS: Record<LogoVariant, string> = {
  black: '/logo/My_Minu_Logo_Version1_black.png',
  white: '/logo/My_Minu_Logo_Version1_white.png',
  beige: '/logo/My_Minu_Logo_Version1_beige.png',
};

const LOGO_HEIGHTS: Record<'small' | 'medium' | 'large', number> = {
  small: 24,
  medium: 36,
  large: 52,
};

export const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  variant = 'black',
  className 
}) => {
  const height = LOGO_HEIGHTS[size];

  return (
    <div className={`${styles.logoContainer} ${className || ''}`}>
      <img
        src={LOGO_PATHS[variant]}
        alt="MyMinu"
        className={styles.logoImage}
        style={{ height: `${height}px` }}
      />
    </div>
  );
};
